import AbstractPilsComponent from './abstract-pils-component';
import pilsTypes from './pils-types';

export default class CartQtyText extends AbstractPilsComponent
{
    constructor(element)
    {
        super(element, pilsTypes.cart);

        this._qtyElementSelector = '.js-cart-qty-text__qty';
        this._qtyElement = null;

        this.init();
    }

    init()
    {
        super.init();
        this._qtyElement = this.fetchQtyElement();
    }

    update(data)
    {
        if (
            !data[this._productNumber] ||
			!data[this._productNumber][this._pilsType]
        )
        {
            return;
        }

        let cartData = data[this._productNumber][this._pilsType];
        let [qty] = Object.values(cartData);

        this._qtyElement.innerText = qty;

        this._element.classList.remove('hidden');
    }

    fetchQtyElement()
    {
        return this._element.querySelector(this._qtyElementSelector);
    }
}
